import { useState, useEffect } from "react";
import { useSearchParams, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Orders from "../../../order/orders/orders.jsx";
import Post_content from '../../../community/content/Blog_posts.jsx';
import { update_input_url_orders } from '../../../order/orders/actions.js';
import axios from "axios";

const Coin_home = () => {
    const { slug_1 } = useParams();
    const [searchParams] = useSearchParams();
    const id_orders = searchParams.get("id_orders");
    const dispatch = useDispatch();
    const set_input_url_orders = (value) => {
        dispatch(update_input_url_orders(value));
    };
    useEffect(() => {
        if (id_orders) {
            axios
                .get("https://hust.media/jop/videos_maker/get_url.php?id_orders=" + id_orders)
                .then((response) => set_input_url_orders(response.data))
                .catch((error) => console.log(error));
        }
    }, []);
    return (
        <>
            {
                id_orders ? (<>
                    <Orders category_main='videos_maker' servicecode='continue' />
                </>) : (
                    <>
                        <Orders category_main='videos_maker' servicecode='new' />
                    </>)
            }
            <Post_content mode={'hust_media'} show_adsense={'NO'} show_adskeeper={'NO'} uri={'maker_clips'} />
        </>
    );
}

export default Coin_home;
